@import url('../../../../node_modules/@splidejs/splide/dist/css/splide-core.min.css');

:host {
  @include reset-host;
}

$modal-vertical-padding: rem(40);

:host .video-modal {
  width: 100%;
  height: 100%;
  padding: $modal-vertical-padding 0;

  background: #1e2330;

  @include mq('max', 'md') {
    padding: 0;
  }

  .ethias-logo {
    position: absolute;
    top: $modal-vertical-padding;
    left: $gutter;

    display: block;

    @include mq('max', 'xl') {
      max-width: rem(80);
      height: auto;
    }
  }

  .desktop-close-button {
    position: absolute;
    top: $modal-vertical-padding;
    right: $gutter;
  }

  .content {
    position: relative;
    aspect-ratio: 9 / 16;

    height: 100%;
    margin: 0 auto;

    @include mq('max', 'sm') {
      aspect-ratio: unset;
    }
  }

  &.has-one-video .content {
    overflow: hidden;

    border-radius: $radius-md;

    @include mq('max', 'md') {
      border-radius: 0;
    }
  }

  .header {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: rem(44) $gutter-mobile;

    border-radius: $radius-md;

    @include mq('max', 'md') {
      padding: rem(24) $gutter-mobile;

      border-radius: 0;
    }

    &:before {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;

      width: 100%;
      height: 100%;

      background: linear-gradient(to bottom, rgba($black, 0.7), transparent);

      content: '';
    }
  }

  .button-group {
    display: flex;
    align-items: center;

    /* stylelint-disable-next-line selector-max-compound-selectors */
    > efb-button + efb-button {
      margin-left: rem(16);
    }
  }

  .tag {
    display: flex;
    align-items: center;
    justify-content: center;
    height: rem(40);
    padding: 12px;

    color: $white;
    font-weight: $fw-medium;
    font-size: $fs-base;
    line-height: 1;

    background: rgba($black, 0.5);
    border-radius: rem(20);
  }

  .external-link-button {
    position: absolute;
    top: calc(100% - #{rem(20)});
    right: $gutter-mobile;

    opacity: 0;

    transition: $transition-smooth;
    transition-property: opacity;

    @include mq('max', 'md') {
      top: calc(100% - #{rem(10)});
    }

    &.is-visible {
      opacity: 1;
    }
  }

  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;

    width: 100%;
  }

  .player-controllers {
    display: flex;
    align-items: center;

    width: 100%;
    padding: rem(24) $gutter-mobile;
    overflow: hidden;

    border-bottom-right-radius: $radius-md;
    border-bottom-left-radius: $radius-md;

    @include mq('max', 'md') {
      border-radius: 0;
    }

    &:before {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;

      width: 100%;
      height: 100%;

      background: linear-gradient(to top, rgba($black, 0.7), transparent);

      content: '';
    }
  }

  .player-seeker-wrapper {
    display: flex;
    flex: 1;
    align-items: center;
    margin-left: rem(20);
  }

  .player-seeker {
    width: 100%;
    height: 5px;
    overflow: hidden;

    background-color: rgba($white, 0.4);
    border-radius: 3px;
    cursor: pointer;

    appearance: none;

    &::-webkit-slider-runnable-track {
      margin-top: -1px;

      color: #13bba4;

      appearance: none;
    }

    &::-webkit-slider-thumb {
      width: 0;
      height: 10px;

      background: transparent;
      box-shadow: -500px 0 0 500px $color-purple-light;
      cursor: ew-resize;

      appearance: none;
    }
  }
}

:host::part(loading-icon) {
  position: absolute;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
}

:host::part(big-play-button) {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;

  font-size: rem(20);

  transform: translate(-50%, -50%);
}
